package com.isaias.fyattravel.web.theme

import org.jetbrains.compose.web.css.Color

/**
 * Unified FYAT Travel Brand Theme
 * Primary: Gold AE7930 | Secondary: Black | Background: White
 */
object ThemeColors {

    // ── Primary Brand Gold ──────────────────────────────────────
    val primary = Color("#AE7930")
    val primaryDark = Color("#8B5E24")
    val primaryMuted = Color("#F5EDE0")
    val primaryLight = Color("#F5EDE0")

    // ── Backgrounds ─────────────────────────────────────────────
    val background = Color("#FFFFFF")
    val surface = Color("#F8F8F8")
    val surfaceElevated = Color("#FFFFFF")
    val inputBackground = Color("#F5F5F5")
    val skeleton = Color("#E5E5E5")
    val skeletonHighlight = Color("#D5D5D5")

    // ── Text Colors ─────────────────────────────────────────────
    val textPrimary = Color("#000000")
    val textSecondary = Color("#333333")
    val textMuted = Color("#666666")
    val textOnGold = Color("#FFFFFF")
    val textOnDark = Color("#FFFFFF")

    // ── Borders ─────────────────────────────────────────────────
    val border = Color("#E5E5E5")
    val borderGold = Color("#AE7930")
    val divider = Color("#E5E5E5")
    val borderLight = Color("#D5D5D5")

    // ── Status ───────────────────────────────────────────────────
    val success = Color("#16a34a")
    val successBg = Color("#f0fdf4")
    val error = Color("#b91c1c")
    val errorBg = Color("#fef2f2")
    val info = Color("#AE7930")
    val warning = Color("#8B5E24")

    // ── Special ──────────────────────────────────────────────────
    val whatsapp = Color("#AE7930")
    val overlay = Color("#000000")
    val shadow = Color("rgba(0,0,0,0.10)")

    // ── Conditional helpers ─────────────────────────────────────
    fun activeTabBg(isActive: Boolean) = if (isActive) primary else surface
    fun activeTabText(isActive: Boolean) = if (isActive) textOnGold else textSecondary
    fun buttonBg(enabled: Boolean) = if (enabled) primary else primaryMuted
    fun selectableBg(isSelected: Boolean) = if (isSelected) primary else surface
    fun selectableText(isSelected: Boolean) = if (isSelected) textOnGold else textSecondary
}
